module.exports = __webpack_public_path__ + "img/AS0770010.3a4f1ac2.jpg";